import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteSubsiteModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteCategoryModalContainer" */
      './DeleteSubsiteModalContainer'
    ),
  loading: LoadingModal,
});
